
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';


    import { DataTableHeader } from 'vuetify';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Wait } from '@/__env/ext';
    import { Chat } from '@/__env/lib/MercadoLibre/Chats';
    import mensajes from './sala-mensajes.vue';
    import principal from './barra-principal/barra-principal.vue';
    import respuestas from './barra-respuestas/barra-respuestas.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            mensajes,
            respuestas,
            principal,
        }
    } )
    export default class Componente extends Vue
    {


        public Activo: boolean = false;


        @Prop() public ControladorPrincipal: ControladorSeccion;
        public get Controlador(): ControladorChatActivo { return this.ControladorPrincipal.Activo; }
        public get Mensajes() { return this.Controlador.Mensajes; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Eventos.push(
                this.ControladorPrincipal.onSeleccionados.subscribe( () =>
                {
                    if ( this.ControladorPrincipal.Seleccionado )
                        this.Iniciar();
                    else
                        this.Activo = false;
                } ) );

        }

        async Iniciar()
        {
            console.log( 'iniciado sala 2' );
            this.Activo = true;
            await this.Controlador.Iniciar();
            if ( this.Mensajes.hasRows() )
            {

                this.Activo = false;
                this.$nextTick( () =>
                {
                    this.Activo = true;
                } );

                await Wait( 100 );
                this.$nextTick( () =>
                {
                    this.Controlador.ScrollYFocus();
                } );
            }
        }



    }
